module.exports = __webpack_public_path__ + "static/img/plansza_old.3ba985cb.png";